// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__Ximi2","active":"styles_active__syG1M"};